import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Users Management',
    url: '/user-management',
    icon: 'fa fa-user'
  },
  {
    name: 'Tab Management',
    url: '/tab-management',
    icon: 'fa fa-th-large',
    children: [
      {
        name: 'Home Tab Management',
        url: '/tab-management/home-tab-management',
        icon: 'fa fa-th-large'
      },
      {
        name: 'Resource Tab Management',
        url: '/tab-management/resource-tab-management',
        icon: 'fa fa-th-large'
      },
    ]
  },
  {
    name: 'Workshop Management',
    url: '/workshop-management',
    icon: 'fa fa-tasks',
    children: [
      {
        name: 'Workshops',
        url: '/workshop-management/list',
        icon: 'fa fa-tasks'
      },
      {
        name: 'Schedule Workshop',
        url: '/workshop-management/schedule-workshop',
        icon: 'fa fa-tasks'
      }
    ]
  },
  {
    name: 'Devotional Management',
    url: '/devotion-management',
    icon: 'fa fa-book',
  },
  {
    name: 'Resource Management',
    url: '/resource-management',
    icon: 'fa fa-users',
    children: [
      {
        name: 'Resources',
        url: '/resource-management/list',
        icon: 'fa fa-users'
      },
      {
        name: 'Schedule Resource',
        url: '/resource-management/schedule-resource',
        icon: 'fa fa-users'
      }
    ]
  },
  // {
  //   name: 'Premium Resource Management',
  //   url: '/premium-resource-management',
  //   icon: 'fa fa-users',
  // },
  {
    name: 'Premium Management',
    url: '/premium-management',
    icon: 'fa fa-star',
  },
  {
    name: 'Tag Management',
    url: '/resource-tag-management',
    icon: 'fa fa-tags',
  },
  {
    name: 'Resource Type Management',
    url: '/resource-type-management',
    icon: 'fa fa-file-o',
  },
  {
    name: 'Groups Management',
    url: '/groups-management',
    icon: 'fa fa-globe',
    children: [
      {
        name: 'Live Groups Management',
        url: '/groups-management/live-groups-management',
        icon: 'fa fa-globe',
      },
      {
        name: 'Facilitator reports',
        url: '/groups-management/facilitator-reports',
        icon: 'fa fa-globe',
      },
      {
        name: 'Facilitate a Legacy Group',
        url: '/groups-management/view-facilitate-group',
        icon: 'fa fa-group',
      },
      {
        name: 'Legacy Ambassador',
        url: '/groups-management/view-ambassador',
        icon: 'fa fa-compass',
      },
    ]
  },
  {
    name: 'Conference Management',
    url: '/conference-management',
    icon: 'fa fa-file',
    children: [
      {
        name: 'Live Conference Management',
        url: '/conference-management/live-conference-managment',
        icon: 'fa fa-users',
      },
      {
        name: 'Archived Conference Management',
        url: '/conference-management/archived-conference-managment',
        icon: 'fa fa-archive',
      },
      {
        name: 'Speaker Management',
        url: '/conference-management/speakers-management',
        icon: 'fa fa-file',
      },
      {
        name: 'Conference Category Management',
        url: '/conference-management/conference-category-management',
        icon: 'fa fa-list-ul',
      },
      {
        name: 'Host an event',
        url: '/conference-management/view-event',
        icon: 'fa fa-calendar-check-o',
      },
    ]
  },
  {
    name: 'Flagged Management',
    url: '/flagged-management',
    icon: 'fa fa-flag-checkered',
    children: [
      {
        name: 'Comments',
        url: '/flagged-management/users',
        icon: 'fa fa-user'
      },
      {
        name: 'Posts',
        url: '/flagged-management/posts',
        icon: 'fa fa-group'
      },
    ]
  },
  {
    name: 'Forum Management',
    url: '/forum-management',
    icon: 'fa fa-users'
  },
  // {
  //   name: 'Notification Management',
  //   url: '/notification-management',
  //   icon: 'fa fa-bell'
  // },
  {
    name: 'Notification Management',
    url: '/notification-management',
    icon: 'fa fa-flag',
    children: [
      {
        name: 'Push Notification',
        url: '/notification-management/push-notification',
        icon: 'fa fa-paper-plane'
      },
      {
        name: 'Scheduled Notifications',
        url: '/notification-management/scheduled-notifications',
        icon: 'fa fa-comments'
      },
    ]
  },
  {
    name: 'App Data Management',
    url: '/app-data-management',
    icon: 'icon-screen-smartphone',
  },
  {
    name: 'Media Management',
    url: '/media-management',
    icon: 'fa fa-camera ',
  },

];
